module.exports = __webpack_public_path__ + "img/door6.39a60dfa.png";